(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-content-pdp"] && !Shopify.designMode) return;
  try {
    
// No JS needed unless you want animations or lazy loading

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["youvee-product-main"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-youvee-product]').forEach((section)=>{const main=section.querySelector('[data-yv-main-image]');section.querySelectorAll('[data-yv-thumb]').forEach((button)=>button.addEventListener('click',()=>{if(!main)return;main.classList.add('is-changing');main.src=button.dataset.imageSrc;main.srcset='';main.alt=button.dataset.imageAlt||'';section.querySelectorAll('[data-yv-thumb]').forEach((thumb)=>{thumb.classList.remove('is-active');thumb.setAttribute('aria-pressed','false')});button.classList.add('is-active');button.setAttribute('aria-pressed','true');requestAnimationFrame(()=>main.classList.remove('is-changing'))}));const price=section.querySelector('[data-yv-price]');section.querySelectorAll('input[name="id"]').forEach((input)=>input.addEventListener('change',()=>{if(price&&input.dataset.price)price.textContent=input.dataset.price}));const quantity=section.querySelector('[data-yv-quantity]');section.querySelectorAll('[data-yv-offer-quantity]').forEach((offer)=>offer.addEventListener('change',()=>{if(quantity)quantity.value=offer.dataset.yvOfferQuantity||'1'}));const selectedOffer=section.querySelector('[data-yv-offer-quantity]:checked');if(quantity&&selectedOffer)quantity.value=selectedOffer.dataset.yvOfferQuantity||'1'});

  } catch(e) { console.error(e); }
})();
})();
